export default __webpack_public_path__ + "static/media/Soundtesting.93ada70d.jpg";